import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiToggleButtonGroup: Components<Theme>['MuiToggleButtonGroup'] = {
  styleOverrides: {
    root: {
      border: `1px solid ${scssVariables.ColorBlack40}`,
      padding: '2px',
      borderRadius: 'var(--border-radius-pill)',
      gap: 'var(--spacing-unit-half)',

      '.MuiToggleButton-root': {
        '&[aria-pressed="true"]': {
          color: scssVariables.ColorBlue80,
        },

        '&:hover': {
          backgroundColor: scssVariables.ColorFog10,
        },
      },

      '.MuiToggleButtonGroup-firstButton': {
        borderTopRightRadius: '50%',
        borderBottomRightRadius: '50%',
      },
      '.MuiToggleButtonGroup-lastButton': {
        borderTopLeftRadius: '50%',
        borderBottomLeftRadius: '50%',
      },
    },
  },
};
